<template>
  <div id="app" class="app" onload="document.body.scrollTop = document.body.scrollHeight">
    <section class="section-header">
      <div class="header-log" @click="goToHome">
        <img src="@/assets/logo.png" alt="" />
      </div>
      <!-- pc端展示的内容 -->
      <ul class="header-nav">
        <li class="header-nav-li" @mouseenter="mouseEnterHandle(item.children, item.type)"
            v-for="item in navList" :key="item.id">
          <router-link class="routerlink" to="/">{{ item.title }}</router-link>
          <ul class="nav-ul-second" v-if="isShowSecond && type === item.type"
              @mouseleave="mouseLeaveHandle">
            <li class="nav-li-second" v-for="second in item.children"
                :key="second.id" @mouseenter="mouseEnterThreeHandle(second.childObj.child,second.childObj.type)">
              <router-link class="routerlink-second" :to="second.path">
                <div>{{ second.title }}</div>
<!--                <sapn class="el-icon-arrow-right routerlink-second-icon"></sapn>-->
              </router-link>
              <!-- <span>{{ second.title }}</span> -->
              <ul class="nav-ul-three" v-if="isShowThree && threeType === second.childObj.type"
                  @mouseleave="mouseLeaveThreeHandle">
                <li class="nav-li-three" v-for="three in second.childObj.child">
                  <router-link class="routerlink-three" :to="three.path">{{ three.title }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="clear"></li>
      </ul>
      <!-- 移动端展示的内容 -->
      <div class="nav-bar-list" v-if="flag">
        <ul class="nav-sm-ul">
          <li class="nav-ul-list">
            <router-link class="first-title" to="/" @click.native="closeNav"
            >首页</router-link
            >
          </li>
          <li class="nav-ul-list" @click="openSecondResource('resource')">
            <span class="first-title">资源</span>
            <span class="el-icon-arrow-down list-icon"></span>
            <ul
                :class="
                isOpenFirstFlagResource
                  ? 'expanded first-ul'
                  : 'is-expanded first-ul'
              "
            >
              <li @click="openThree('germplasm')">
                <span class="first-title">种质资源</span>
                <span class="el-icon-arrow-down list-icon-second"></span>
                <ul
                    class="expanded-second second-ul"
                    v-if="!isOpenThreeGermplasm"
                >
                  <li>
                    <router-link
                        to="/resourceBase/germplasm/seed"
                        class="first-title"
                        @click.native="closeNav"
                    >种子</router-link
                    >
                  </li>
                  <li>
                    <router-link
                        to="/resourceBase/germplasm/driedLeaf"
                        class="first-title"
                        @click.native="closeNav"
                    >干燥叶片</router-link
                    >
                  </li>
                  <li>
                    <router-link
                        to="/resourceBase/germplasm/dna"
                        class="first-title"
                        @click.native="closeNav"
                    >DNA</router-link
                    >
                  </li>
                  <li>
                    <router-link
                        to="/resourceBase/germplasm/germplasmAnimal"
                        class="first-title"
                        @click.native="closeNav"
                    >动物种质</router-link
                    >
                  </li>
                </ul>
              </li>
              <li @click="openThree('dna')">
                <span class="first-title">DNA条形码</span>
                <span class="el-icon-arrow-down list-icon-second"></span>
                <ul class="expanded-second second-ul" v-if="!isOpenThreeDna">
                  <li>
                    <router-link
                        to="/resourceBase/dnaBar/spineAnimal"
                        class="first-title"
                        @click.native="closeNav"
                    >脊椎动物</router-link
                    >
                  </li>
                  <li>
                    <router-link
                        to="/resourceBase/dnaBar/vascularPlant"
                        class="first-title"
                        @click.native="closeNav"
                    >维管植物</router-link
                    >
                  </li>
                </ul>
              </li>
              <li @click="openThree('workGuide')">
                <span class="first-title">名录</span>
                <span class="el-icon-arrow-down list-icon-second"></span>
                <ul
                    class="expanded-second second-ul"
                    v-if="!isOpenThreeWorkGuide"
                >
                  <li>
                    <router-link
                        @click.native="closeNav"
                        to="/resourceBase/list/protectList"
                        class="first-title"
                    >高黎贡山国家重点保护野生植物名录</router-link
                    >
                  </li>
                  <li>
                    <router-link
                        @click.native="closeNav"
                        to="/resourceBase/list/uniqueList"
                        class="first-title"
                    >高黎贡山特有植物名录</router-link
                    >
                  </li>
                  <li>
                    <router-link
                        @click.native="closeNav"
                        to="/resourceBase/list/wildPlants"
                        class="first-title"
                    >怒江州高黎贡山野生植物名录</router-link
                    >
                  </li>
                  <li>
                    <router-link
                        @click.native="closeNav"
                        to="/resourceBase/list/terrestrialWildlife"
                        class="first-title"
                    >怒江州高黎贡山陆生野生动物（脊椎动物）</router-link
                    >
                  </li>
                  <li>
                    <router-link
                        @click.native="closeNav"
                        to="/resourceBase/list/protectedWildPlants"
                        class="first-title"
                    >高黎贡山-伯舒拉岭重点保护野生植物名录</router-link
                    >
                  </li>
                </ul>
              </li>
              <li @click="openThree('list')">
                <span class="first-title">工作指南</span>
                <span class="el-icon-arrow-down list-icon-second"></span>
                <ul class="expanded-second second-ul" v-if="!isOpenThreeList">
                  <li>
                    <router-link
                        to="/resourceBase/workGuide/management"
                        class="first-title"
                        @click.native="closeNav"
                    >种质资源采集和管理规范</router-link
                    >
                  </li>
                  <li>
                    <router-link
                        to="/resourceBase/workGuide/filling"
                        class="first-title"
                        @click.native="closeNav"
                    >野外数据填写规范 (植物)</router-link
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li class="nav-ul-list" @click="openSecond('information')">
            <span class="first-title">动态</span>
            <span class="el-icon-arrow-down list-icon"></span>
            <ul class="expanded first-ul" v-if="!isOpenFirstFlagInformation">
              <li>
                <router-link
                    to="/dynamic/information"
                    class="first-title"
                    @click.native="closeNav"
                >动态资讯</router-link
                >
              </li>
              <li>
                <router-link
                    to="/dynamic/progressWork"
                    class="first-title"
                    @click.native="closeNav"
                >工作进展</router-link
                >
              </li>
            </ul>
          </li>
          <li class="nav-ul-list" @click="openSecond('scientific')">
            <span class="first-title">科考影像</span>
            <span class="el-icon-arrow-down list-icon"></span>
            <ul class="expanded first-ul" v-if="!isOpenFirstFlagScientific">
              <li>
                <router-link
                    to="/scientificResearch/video"
                    class="first-title"
                    @click.native="closeNav"
                >视频</router-link
                >
              </li>
              <li>
                <router-link
                    to="/scientificResearch/picture"
                    class="first-title"
                    @click.native="closeNav"
                >图片</router-link
                >
              </li>
            </ul>
          </li>
          <li class="nav-ul-list" @click="openSecond('help')">
            <span class="first-title">帮助</span>
            <span class="el-icon-arrow-down list-icon"></span>
            <ul class="expanded first-ul" v-if="!isOpenFirstFlagHelp">
              <li>
                <router-link
                    to="/help/problem"
                    class="first-title"
                    @click.native="closeNav"
                >常见问题</router-link
                >
              </li>
              <li>
                <router-link
                    to="/help/relationWe"
                    class="first-title"
                    @click.native="closeNav"
                >联系我们</router-link
                >
              </li>
            </ul>
          </li>
          <!-- <li class="nav-ul-list-button" v-if="!this.$store.state.user_info"> -->
          <li class="nav-ul-list">
            <el-button @click="toLogin">登录</el-button>
            <el-button @click="toRegister">注册</el-button>
          </li>
          <!-- <li class="nav-ul-list-button" v-else>
            <div class="userInfo">
              <el-dropdown @command="handleCommand">
                <i class="iconfont icon-yonghu userInfo-icon"></i>
                <span class="el-dropdown-link userInfo-name">
                  {{ JSON.parse(this.$store.state.user_info).name }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="home">首页</el-dropdown-item>
                  <el-dropdown-item command="userinfo"
                    >个人信息</el-dropdown-item
                  >
                  <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </li>  -->
        </ul>
      </div>
      <!--
     <div>
       <div class="header-login" v-if="!this.$store.state.user_info">
         <div class="login" @click="toLogin">登录</div>
         <div class="register" @click="toRegister">注册</div>
       </div>
       <div v-else class="header-userInfo" >
         <el-dropdown @command="handleCommand">
           <i class="iconfont icon-yonghu" style="font-size: 25px;margin-right: 5px;"></i>
           <span class="el-dropdown-link userInfo-name" style="margin-right: 10px">
            {{JSON.parse(this.$store.state.user_info).name}}
          </span>
           <el-dropdown-menu slot="dropdown" >
             <el-dropdown-item command="home">首页</el-dropdown-item>
             <el-dropdown-item command="userinfo">个人信息</el-dropdown-item>
             <el-dropdown-item command="logout" >退出登录</el-dropdown-item>
           </el-dropdown-menu>
         </el-dropdown>
       </div>
     </div>
      <div class="header-login-caidan" @click="menuHandle">
        <i class="iconfont icon-caidan"></i>
      </div>
      <div class="clear"></div>
     -->
    </section>
    <section class="section-main"><router-view /></section>
    <section class="section-footer">
<!--      <div class="footer-left">-->
<!--        项目资助：科技基础性工作专项“大高黎贡山野生生物种质资源的调查收集与保存”（2021FY100200）-->
<!--      </div>-->
      <div class="footer-container">
        <ul class="footer-container-project">
        <div>项目合作单位</div>
          <li class="footer-container-project-li" v-for="item in projectList" :key="item.id" @click="goToLink(item.url)">
            <img v-for="(img, index) in item.cooperativeUnitFileList" :key="index"
                class="footer-container-project-img"
                :src="img.url"
                :alt="item.title" :title="item.title"/>
          </li>
        </ul>
      </div>
      <div class="footer-right">
        <p>Copyright 2022 中国科学院昆明植物研究所</p>
        <div>地址：云南省昆明市盘龙区蓝黑路132号</div>
        <p>电话：0871-65223223 滇ICP备05000394号</p>
      </div>
    </section>
  </div>
</template>
<script>
import { getOtherFile } from './network/common'
import { FileDown } from './utils/util'
import homeFooter from "@/components/homeChild/homeFooter";
import { getGlobalInfo } from '@/network/searchPage'
import store from "@/store";
import {getUserInfo, logout} from '@/network/login'
import {cooperativeunit} from "@/network/cooperativeunit";
export default  {
  components: { homeFooter },
  data() {
    return {
      isShowSecond: false,
      isShowThree: false,
      type: "home",
      threeType: "germplasmResource",
      navList: [
        { id: 0, title: "首页", children: [], type: "home", path: "/" },
        {
          id: 1,
          title: "资源",
          type: "resource",
          children: [
            {
              id: 101,
              title: "种质资源",
              path: "",
              childObj: {
                child: [
                  {
                    id: 1101,
                    title: "植物种质",
                    path: "/resourceBase/germplasm/seed",
                  },
                  // {
                  //   id: 1102,
                  //   title: "干燥叶片",
                  //   path: "/resourceBase/germplasm/driedLeaf",
                  // },
                  // {
                  //   id: 1103,
                  //   title: "DNA",
                  //   path: "/resourceBase/germplasm/dna",
                  // },
                  {
                    id: 1104,
                    title: "动物种质",
                    path: "/resourceBase/germplasm/germplasmAnimal",
                  },
                ],
                type: "germplasmResource",
              },
            },
            {
              id: 102,
              title: "DNA条形码",
              path: "",
              childObj: {
                child: [
                  {
                    id: 1202,
                    title: "维管植物",
                    type: "dna",
                    path: "/resourceBase/dnaBar/vascularPlant",
                  },
                  {
                    id: 1201,
                    title: "脊椎动物",
                    type: "dna",
                    path: "/resourceBase/dnaBar/spineAnimal",
                  },

                ],
                type: "dna",
              },
            },
            {
              id: 103,
              title: "名录",
              path: "",
              childObj: {
                child: [
                  {
                    id: 1301,
                    title: "高黎贡山-伯舒拉岭受威胁植物名录",
                    type: "list",
                    path: "/resourceBase/list/protectList",
                  },
                  {
                    id: 1302,
                    title: "高黎贡山特有植物名录",
                    type: "list",
                    path: "/resourceBase/list/uniqueList",
                  },
                  {
                    id: 1303,
                    title: "怒江州高黎贡山野生植物名录",
                    type: "list",
                    path: "/resourceBase/list/wildPlants",
                  },
                  {
                    id: 1304,
                    title: "怒江州高黎贡山陆生野生动物（脊椎动物",
                    type: "list",
                    path: "/resourceBase/list/terrestrialWildlife",
                  },
                  // {
                  //   id: 1306,
                  //   title: "高黎贡山-伯舒拉岭重点保护野生植物名录",
                  //   type: "list",
                  //   path: "/resourceBase/list/protectedWildPlants",
                  // },
                ],
                type: "list",
              },
            },
            {
              id: 104,
              title: "工作指南",
              path: "",
              childObj: {
                child: [
                  {
                    id: 1401,
                    title: "种质资源采集和管理规范",
                    type: "work",
                    path: "/resourceBase/workGuide/management",
                  },
                  {
                    id: 1402,
                    title: "野外数据填写规范 (植物)",
                    type: "work",
                    path: "/resourceBase/workGuide/filling",
                  },
                  {
                    id: 1403,
                    title: "",
                    type: "work",
                    path: "",
                  },
                  {
                    id: 1404,
                    title: "",
                    type: "work",
                    path: "",
                  },
                ],
                type: "work",
              },
            },
          ],
        },
        {
          id: 2,
          title: "动态",
          children: [
            {
              id: 201,
              title: "动态资讯",
              path: "/dynamic/information",
              childObj: { child: [] },
            },
            {
              id: 202,
              title: "工作进展",
              path: "/dynamic/progressWork",
              childObj: { child: [] },
            },{
              id: 203,
              title: "标准规范",
              path: "/dynamic/standardSpecification",
              childObj: { child: [] },
            },{
              id: 204,
              title: "帮助文档",
              path: "/dynamic/helpDocuments",
              childObj: { child: [] },
            },
          ],
          type: "dynamic",
        },
        {
          id: 3,
          title: "影像",
          children: [
            {
              id: 301,
              title: "图片",
              path: "/scientificResearch/picture",
              childObj: { child: [] },
            },
            {
              id: 302,
              title: "视频",
              path: "/scientificResearch/video",
              childObj: { child: [] },
            },
          ],
          type: "scientific",
        },
        {
          id: 4,
          title: "帮助",
          children: [
            {
              id: 401,
              title: "常见问题",
              path: "/help/problem",
              childObj: { child: [] },
            },
            {
              id: 402,
              title: "联系我们",
              path: "/help/relationWe",
              childObj: { child: [] },
            },
          ],
          type: "help",
        },
      ],
      flag: false,
      //-----------
      isOpenFirstFlagInformation: true,
      isOpenFirstFlagScientific: true,
      isOpenFirstFlagHelp: true,
      isOpenFirstFlagResource: false,
      isOpenThreeGermplasm: true,
      isOpenThreeDriedLeaf: true,
      isOpenThreeDna: true,
      isOpenThreeWorkGuide: true,
      isOpenThreeList: true,

      //-----------
      searchForm: {},
      active: '',
      flag1: 0,
      searchFlag: 0,
      searchActive: '',
      currentIndexSearch: 0,
      currentIndex: 0,
      userActive: '',
      sysUser: {},
      isLogout: false,
      dialogVisible:false,
      loginForm: {},
      rules: {},
      // 刷新token锁
      refreshLock: false,
      // 刷新token的时间
      refreshTime: '',
      // 计时器
      timer: '',
      showName: '',//右上姓名
      userinfo: {},
      //全局检索
      searchPage: 1,
      searchPageSize: 10,
      searchTotal: 0,
      historyActive: '',
      historyFlag: 0,
      searchHistoryList: [],//搜索历史数组
      showLi: false,
      clearFlag: 0,
      pvId: 0,
      type1: 'nujiangPrefectureWildPlants',
      type2: 'terrestrialWildlife',
      prefectureWildPlants: [],
      terrestrialWildlife: [],
      tag: 0,
      title: '',
      listDialog: false,
      //项目合作单位
      projectList: []
    }
  },
  created() {
    // this.showName = JSON.parse(localStorage.getItem('userinfo')).name
    // this.userinfo = JSON.parse(localStorage.getItem('userinfo'))
   window.localStorage.setItem('searchList', JSON.stringify([]))
    this.searchHistoryList = JSON.parse(localStorage.getItem('searchList'))
    // console.log(this.searchHistoryList)
    //去重
    this.searchHistoryList = this.searchHistoryList.reduce((accumulator, current) => {
      if (!accumulator.some(item => JSON.stringify(item) === JSON.stringify(current))) {
        accumulator.push(current);
      }
      return accumulator;
    }, []);
    // console.log('4',this.searchHistoryList)

    // main.style.minHeight = (window.innerHeight - header.offsetHeight - footer.offsetHeight) + 'px'
  },
  mounted() {
    // this.$store.dispatch("GetUserInfo").then((res) => {
    //   // console.log('userinfo',res)
    // })
/*
    getUserInfo().then(res => {
      // console.log(res)
      if(res.data.code == 0) {
        window.localStorage.setItem('userinfo',JSON.stringify(res.data.data.sysUser))
      } else {
      }
    }).catch((err)=>{
    })
    */
    this.getProjectList()
  },
  methods: {
    goToHome() {
      this.$router.push('/')
    },
    /**
     * 项目合作单位跳转
     */
    goToLink(url) {
      window.open(url, '_blank')
    },
    //  项目合作单位
    getProjectList() {
      cooperativeunit().then(res => {
        // console.log(res)
        this.projectList = res.data.data.records
        // this.projectList =  res.data.data.records.slice(0,5)
      })
    },
    toLogin() {
      this.$router.push("login");
      this.flag = !this.flag;
    },
    toRegister() {
      this.$router.push("register");
      this.flag = !this.flag;
    },
    openSecond(val) {
      // console.log(val)
      if (val === "information") {
        this.isOpenFirstFlagInformation = !this.isOpenFirstFlagInformation;
      } else if (val === "scientific") {
        this.isOpenFirstFlagScientific = !this.isOpenFirstFlagScientific;
      } else if (val === "help") {
        this.isOpenFirstFlagHelp = !this.isOpenFirstFlagHelp;
      }
    },
    openSecondResource() {
      this.isOpenFirstFlagResource = !this.isOpenFirstFlagResource;
    },
    openThree(val) {
      if (val === "germplasm") {
        this.isOpenThreeGermplasm = !this.isOpenThreeGermplasm;
        this.isOpenFirstFlagResource = !this.isOpenFirstFlagResource;
      } else if (val === "dna") {
        this.isOpenThreeDna = !this.isOpenThreeDna;
        this.isOpenFirstFlagResource = !this.isOpenFirstFlagResource;
      } else if (val === "workGuide") {
        this.isOpenThreeWorkGuide = !this.isOpenThreeWorkGuide;
        this.isOpenFirstFlagResource = !this.isOpenFirstFlagResource;
      } else if (val === "list") {
        this.isOpenThreeList = !this.isOpenThreeList;
        this.isOpenFirstFlagResource = !this.isOpenFirstFlagResource;
      }
    },
    menuHandle() {
      this.flag = !this.flag;
    },
    mouseEnterHandle(child, itemType) {
      if (child.length > 0 && itemType === "help") {
        this.isShowSecond = true;
        this.type = itemType;
      } else if (child.length > 0 && itemType === "resource") {
        this.isShowSecond = true;
        this.type = itemType;
      } else if (child.length > 0 && itemType === "scientific") {
        this.isShowSecond = true;
        this.type = itemType;
      } else if (child.length > 0 && itemType === "dynamic") {
        this.isShowSecond = true;
        this.type = itemType;
      }
    },
    mouseLeaveHandle() {
      this.isShowSecond = false;
      this.type = "";
    },
    mouseEnterThreeHandle(child, type) {
      // console.log(type);
      if (child.length > 0 && type === "germplasmResource") {
        this.isShowThree = true;
        this.threeType = type;
        // console.log(this.threeType, type);
      } else if (child.length > 0 && type === "dna") {
        this.isShowThree = true;
        this.threeType = type;
      } else if (child.length > 0 && type === "list") {
        this.isShowThree = true;
        this.threeType = type;
      } else if (child.length > 0 && type === "work") {
        this.isShowThree = true;
        this.threeType = type;
      }
    },
    mouseLeaveThreeHandle() {
      this.isShowThree = false;
      this.threeType = "";
    },
    //-----------
    goSearchHandle(val){
      this.$router.push('/searchPage?title=' + val)
    },
    closeNav(){
      this.flag = !this.flag
    },
    // openSecond(val){
    //   // console.log(val)
    //   if(val === 'information' ) {
    //     this.isOpenFirstFlagInformation = !this.isOpenFirstFlagInformation
    //   } else if(val === 'scientific') {
    //     this.isOpenFirstFlagScientific = !this.isOpenFirstFlagScientific
    //    } else if(val === 'help') {
    //     this.isOpenFirstFlagHelp = !this.isOpenFirstFlagHelp
    //   }
    // },
    handDownloadFile(row) {
      // console.log(row)
      FileDown(row.bucketName, row.fileName, row.name).then(res => {})
    },
    clickHandle(val,i) {
      this.tag = i
      this.listDialog = true
      this.title = val
      if(i === 1) {
        getOtherFile(this.pvId,this.type).then(res=>{
          this.prefectureWildPlants = res.data.data
        })
      } else if(i === 2) {
        getOtherFile(this.pvId,this.type2).then(res=>{
          this.terrestrialWildlife = res.data.data
        })
      }

    },
   /* refreshToken() {
      this.refreshTime = setInterval(() => {
        const token = this.$store.state.access_token
        let expires_in = localStorage.getItem('expires_in')
        if (expires_in <= 60 && !this.refreshLock) {
          this.refreshLock = true
          this.$store.dispatch('RefreshToken')
              .catch(() => {
                clearInterval(this.refreshTime)
              })
          this.refreshLock = false
        }
        this.$store.commit('setExpiresIn', expires_in - 10)
      }, 10000)
    },
    */
    onSubmit(val) {
      getGlobalInfo({title: this.searchForm.title,page: this.searchPage,pageSize: this.searchPageSize}).then(res => {
        // console.log('getGlobalInfo',res)
        this.searchList = res.data.data.globalVoList
        this.searchTotal = res.data.data.total
        this.$EventBus.$emit('searchEvent', this.searchList, this.searchTotal,
            this.searchPage,this.searchPageSize, this.searchForm.title)
      })
      this.setHistory(this.searchForm.title)
      //跳转页面
      this.$router.push({path: '/searchPage', query:{title: this.searchForm.title}})
      // this.$router.push({path: '/searchPage',query:{title: JSON.stringify(this.searchForm.title)}})
    this.showLi = false
    },
    inputHandle(eve,item) {
      // console.log(eve)
      if(item.title) {
      // this.clearFlag = 1
        // if(parseInt(eve) !==0)
        this.searchForm.title = eve
      }
    },

    clearInput(event) {
      // console.log(event)
      this.clearFlag = 1
      this.searchForm.title = ''
      this.showLi = false
    },
    setHistory (val) {
      // console.log(val)
      if(!val) {
        return
      }
      if(!localStorage.getItem('searchList')) {
        //没有
        localStorage.setItem('searchList', '[]')
      } else  {
        this.searchHistoryList = JSON.parse(localStorage.getItem('searchList'))
      }
      // console.log(this.searchHistoryList)
      //增加数据
      this.searchHistoryList.unshift(val)
      //去重
      // let newArr = new Set(this.searchHistoryList)
      // let newArr = Array.from(new Set(this.searchHistoryList.map(JSON.stringify))).map(JSON.parse);
     const uniqueSearchHistoryList = this.searchHistoryList.reduce((accumulator, current) => {
        if (!accumulator.some(item => JSON.stringify(item) === JSON.stringify(current))) {
          accumulator.push(current);
        }
        return accumulator;
      }, []);
      //给本地存储
      // localStorage.setItem('searchList', JSON.stringify(newArr));
      localStorage.setItem("searchList", JSON.stringify(uniqueSearchHistoryList));
      // console.log('234567',uniqueSearchHistoryList)
      // localStorage.setItem('searchList', JSON.stringify(Array.from(newArr)))

    },
    handleSelect(key, keyPath) {
      if(key== '/logout') {
        logout().then(res => {
          if(res.data.code == 0) {
            window.localStorage.clear()
            this.$store.state.user_info = ''
            this.userinfo = {}
            this.$store.state.certification = 0
            this.$message.success('退出成功!')
            this.$router.push('/')
            location.reload()
          }
        })
      }
      this.$router.push({path:key}).catch(err => {
        // console.log(err)
      })
      this.flag = 0
      this.active = 'nav-sm'
    },
    handleOpen(key, keyPath) {
      this.$router.push({path:key}).catch(err => {
        // console.log(err)
      })
    },
    handleClose(key, keyPath) {
    },
    toHome(){
      this.$router.push('/')
    },
    searchHandle() {
      // console.log(this.searchFlag)
      if(this.searchFlag == 0) {
        this.searchActive = 'header-sm-search'
          this.searchFlag = 1
      }else {
          this.searchActive = 'sm-block'
          this.searchFlag = 0
        }
    },
    getUserInfo() {
      getUserInfo().then(res => {
        // console.log(res)
        this.sysUser = res.data.data.sysUser
      })
    },
    handleCommand(command) {
      if(command == 'logout') {
          logout().then(res => {
            if(res.data.code == 0) {
              // window.localStorage.clear()
              this.$store.state.user_info = ''
              this.userinfo = {}
              this.$store.state.certification = 0
              window.localStorage.clear();
              location.reload()
              this.$message.success('退出成功!')
              this.$router.push('/')
              location.reload()
            } else {

            }
        })
      }else if(command == 'home'){
        this.$router.push('/')
      }else {
        this.$router.push('/userInfo')
      }
    },
  }
}
</script>
<style lang="scss"  scoped>
//@import "@/assets/css/app.scss";
@import "./assets/css/app.scss";
.el-message {
  margin-top: 70px !important;
  z-index: 10000 ;
}
::v-deep .routerlink {
  color: #2A82E4 !important;
}

</style>
